module.exports = __webpack_public_path__ + "img/illustrate02.e227e188.png";